import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { isHyphenatedLocale, LocaleContext } from '../locale/i18n'
import { IContentfulLanding, IContentfulMethod } from '../logic/shared-types'

import MeasurImage from './MeasurImage'

import './CollectionCard.scss'

export type CollectionCardProps = Partial<
  Pick<
    IContentfulLanding,
    'heroImage' | 'heroImageFull' | 'heroImageThumbnail' | 'slug' | 'heroTitle'
  > &
    Pick<
      IContentfulMethod,
      | 'heroImage'
      | 'heroImageFull'
      | 'heroImageThumbnail'
      | 'slug'
      | 'acronym'
      | 'methodNameLong'
    >
> & {
  path: string
}

const CollectionCard = ({
  acronym,
  heroImageThumbnail,
  heroTitle,
  methodNameLong,
  path,
  slug,
}: CollectionCardProps) => {
  const { t } = useContext(LocaleContext)

  return (
    <Link className="collectionCard" to={[path, slug, '/'].join('')}>
      {heroImageThumbnail && (
        <MeasurImage
          className="collectionCard__thumbnail"
          image={heroImageThumbnail.gatsbyImageData}
          alt=""
        />
      )}
      <div className="collectionCard__content">
        <div className="collectionCard__titleRow">
          <h3
            className={classNames('collectionCard__title', {
              hyphenate: isHyphenatedLocale(),
            })}
          >
            {methodNameLong ?? heroTitle}
          </h3>
          {acronym && <div className="collectionCard__acronym">{acronym}</div>}
        </div>
        <div className="collectionCard__spacer" />
        <p>
          <span className="collectionCard__readMore">
            {t('common.readMore')} &gt;
          </span>
        </p>
      </div>
    </Link>
  )
}

export default CollectionCard
